import React from 'react';
import { Box, Typography } from '@mui/material';
import { pageCardSx } from '../styles/formStyles';
import { smallCompletedStepIconSx } from '../styles/iconStyles';

export const wizardPageShellSx = {
  width: '100%',
  maxWidth: { xs: '100%', lg: 1360, xl: 1280 },
  boxSizing: 'border-box',
  mx: 'auto',
  px: { xs: 0.5, sm: 1, lg: 3, xl: 4 },
};

export const wizardWidePageShellSx = {
  width: '100%',
  maxWidth: { xs: '100%', lg: 1480, xl: 1400 },
  boxSizing: 'border-box',
  mx: 'auto',
  px: { xs: 0.5, sm: 1, lg: 3, xl: 4 },
};

export const wizardPageTitleSx = {
  fontSize: { xs: 28, sm: 30, md: 34 },
  lineHeight: { xs: '34px', sm: '36px', md: '40px' },
  letterSpacing: '-0.25px',
  fontWeight: 700,
  color: '#1C1B1F',
};

export const wizardPageSubtitleSx = {
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#1C1B1F',
};

export const wizardSidebarGridSx = {
  display: 'flex',
};

export const wizardSidebarCardSx = {
  ...pageCardSx,
  p: { xs: 2.5, sm: 3, md: 3.5 },
  width: '100%',
  height: '100%',
};

export const wizardContentGridSx = {
  display: 'flex',
};

export const wizardContentCardSx = {
  ...pageCardSx,
  p: { xs: 2.5, sm: 3, md: 4 },
  width: '100%',
  height: '100%',
};

export const wizardSectionCardSx = {
  ...pageCardSx,
  p: { xs: 2.5, sm: 3, md: 3.5 },
};

export const wizardStickyFooterSx = {
  ...pageCardSx,
  position: 'sticky',
  bottom: { xs: 12, md: 16 },
  p: 2.5,
  display: 'flex',
  flexDirection: { xs: 'column-reverse', md: 'row' },
  alignItems: { xs: 'stretch', md: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  zIndex: 2,
};

export const wizardTextActionButtonSx = {
  textTransform: 'none',
  color: '#294190',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  px: 2,
  width: { xs: '100%', sm: 'auto' },
};

export const wizardSecondaryButtonSx = {
  minWidth: { sm: 140 },
  height: 40,
  borderRadius: '10px',
  textTransform: 'none',
  border: '1px solid #294190',
  color: '#294190',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  width: { xs: '100%', sm: 'auto' },
};

export const wizardPrimaryButtonSx = {
  minWidth: { sm: 140 },
  height: 40,
  borderRadius: '10px',
  textTransform: 'none',
  bgcolor: '#294190',
  color: '#FFFFFF',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  width: { xs: '100%', sm: 'auto' },
  boxShadow: 'none',
  '&:hover': {
    bgcolor: '#294190',
    boxShadow: 'none',
  },
};

export const wizardPositiveActionButtonSx = {
  minWidth: { sm: 190 },
  height: 44,
  borderRadius: '10px',
  textTransform: 'none',
  border: '1px solid #76A312',
  color: '#4F8506',
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  fontWeight: 600,
  width: { xs: '100%', sm: 'auto' },
};

export const wizardStepRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const wizardReadOnlyDetailSx = {
  display: 'grid',
  gap: 0.5,
};

export const wizardReadOnlyLabelSx = {
  fontSize: 12,
  lineHeight: '16px',
  letterSpacing: '0.4px',
  fontWeight: 500,
  color: '#6B6880',
};

export const wizardReadOnlyValueSx = {
  fontSize: 15,
  lineHeight: '22px',
  color: '#1C1B1F',
};

export const wizardSectionHeaderWrapSx = {
  mb: 3,
};

export const wizardSectionHeaderTitleSx = {
  fontSize: 20,
  lineHeight: '28px',
  fontWeight: 700,
  color: '#1C1B1F',
  mb: 0.75,
};

export const wizardSectionHeaderHelperTextSx = (emphasized = false) => ({
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  color: emphasized ? '#294190' : '#6B6880',
});

export const wizardInfoTextSx = {
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  color: '#6B6880',
  mt: 1,
};

export const wizardDependentFieldTextSx = {
  fontSize: 14,
  lineHeight: '20px',
  color: '#294190',
  fontWeight: 500,
};

export const wizardDependentFieldWrapSx = {
  minHeight: 40,
  display: 'flex',
  alignItems: 'center',
};

export function FinancialSupportStepBullet({ step }) {
  if (step.completed) {
    return (
      <Box
        sx={{
          width: 21,
          height: 21,
          borderRadius: '50%',
          bgcolor: '#4F8506',
          color: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box component="span" className="material-symbols-rounded" sx={smallCompletedStepIconSx}>
          check
        </Box>
      </Box>
    );
  }

  if (step.active) {
    return (
      <Box
        sx={{
          width: 21,
          height: 21,
          borderRadius: '50%',
          bgcolor: '#4F8506',
          color: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 12,
          lineHeight: '16px',
          fontWeight: 700,
        }}
      >
        {step.id}
      </Box>
    );
  }

  return <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#666666', flexShrink: 0 }} />;
}

export function FinancialSupportWizardSidebar({ steps }) {
  return (
    <Box sx={wizardSidebarCardSx}>
      <Box sx={{ display: 'grid', gap: 3 }}>
        {steps.map((step) => {
          const active = step.active || step.completed;

          return (
            <Box key={step.id} sx={wizardStepRowSx}>
              <FinancialSupportStepBullet step={step} />
              <Typography
                sx={{
                  fontSize: active ? 16 : 15,
                  lineHeight: '24px',
                  letterSpacing: '0.15px',
                  fontWeight: active ? 700 : 400,
                  color: active ? '#1C1B1F' : '#666666',
                }}
              >
                {step.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export function FinancialSupportSectionHeader({ title, helperText, emphasized = false }) {
  return (
    <Box sx={wizardSectionHeaderWrapSx}>
      <Typography sx={wizardSectionHeaderTitleSx}>{title}</Typography>
      <Typography sx={wizardSectionHeaderHelperTextSx(emphasized)}>{helperText}</Typography>
    </Box>
  );
}

export function FinancialSupportReadOnlyDetail({ label, value }) {
  return (
    <Box sx={wizardReadOnlyDetailSx}>
      <Typography sx={wizardReadOnlyLabelSx}>{label}</Typography>
      <Typography sx={wizardReadOnlyValueSx}>{value || '-'}</Typography>
    </Box>
  );
}
